import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { cloneDeep } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { successMessageToast } from "helpers/common";
import { MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST, MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { STATUS_OPTIONS } from "config/constants";
import { CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import { useCreateTemplateMutation, useGetTemplateDetailQuery, useLazyGetHtmlTemplateQuery, useUpdateTemplateMutation, } from "store/services/notification";
import addTemplateSchema from "./addTemplate.schema";

const AddFirebaseNotificationTemplate = () => {
  const { id: templateId } = useParams();
  const editMode = !!templateId;
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({

    template_desc: "",
    firebase_heading: "",
    firebase_content: "",
    firebase_status: STATUS_OPTIONS[0],
    email_status: "active",
  });

  const [updateTemplate, { isLoading: updateCmsLoading }] = useUpdateTemplateMutation();
  const [createTemplate, { isLoading: createCmsLoading }] = useCreateTemplateMutation();
  const { data: templateDetails, isLoading } = templateId ? useGetTemplateDetailQuery(templateId) : {};

  const handleSubmit = async (payload) => {
    try {
      const values = cloneDeep(payload);
      values.email_status = payload?.email_status;
      values.firebase_status = payload?.firebase_status?.value;

      const result = editMode
        ? await updateTemplate({ data: values, templateId })
        : await createTemplate(values);
      if (result?.error) {
        console.error("Error create notification template", result.error);
        return;
      }

      successMessageToast(result?.data?.message);
      navigate(MANAGE_NOTIFICATION_FIREBASE_TEMPLATE_LIST);
    } catch (err) {
      console.error("Error create  notification template", err);
    }
  };

  useEffect(() => {
    if (!templateId) return;

    if (templateDetails) {

      setInitialValues({
        template_desc: templateDetails?.template_desc || "",
        email_status: "active",
        firebase_heading: templateDetails?.firebase_heading || "",
        firebase_content: templateDetails?.firebase_content || "",
        firebase_status: STATUS_OPTIONS.find((x) => x.value == templateDetails?.firebase_status) || ""
      });
    }
  }, [templateDetails]);

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <div className="pageHead pb-3">
                    <h6 className="m-0 fw-bold themeBlue">
                      {editMode ? "Edit Template" : "Add New Template"}
                    </h6>
                  </div>
                </div>
              </div>
            </Col>
            {isLoading ? (
              <LoadingIndicator />
            ) : (
              <>
                <Row>
                  <Col lg="12" className="my-2  shadow-lg">
                    <Formik
                      initialValues={initialValues}
                      validationSchema={addTemplateSchema}
                      onSubmit={handleSubmit}
                      enableReinitialize
                    >
                      {({ handleSubmit, handleChange, values, errors }) => (
                        <Form onSubmit={handleSubmit}>
                          <div
                            className="py-3"
                            style={{ borderTop: "1px solid #41a2a84d" }}
                          >
                            <Row>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  Description
                                  <RequiredFieldAstrick />
                                </label>
                                <AppInputField
                                  type="text"
                                  fieldType={'textarea'}
                                  name="template_desc"
                                  placeholder="Enter Title"
                                  className={`${styles.formControl} form-control`}
                                  maxLength={500}
                                />
                              </Col>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  Status
                                  <RequiredFieldAstrick />
                                </label>
                                <CommonSelect
                                  name="firebase_status"
                                  placeholder="Select Firebase Status"
                                  className={`${styles.formControl} form-control`}
                                  option={STATUS_OPTIONS}
                                />
                              </Col>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  Firebase Heading
                                </label>
                                <AppInputField
                                  type="text"
                                  name="firebase_heading"
                                  placeholder="Enter Firebase Content"
                                  className={`${styles.formControl} form-control`}
                                  maxLength={500}
                                />
                              </Col>
                              <Col md="12" sm="12" className="my-2">
                                <label
                                  htmlFor=""
                                  className="form-label themeBlue fw-bold mb-0 d-flex"
                                >
                                  FIrebase Content
                                </label>
                                <AppInputField
                                  type="text"
                                  fieldType={'textarea'}
                                  style={{ minHeight: "80px" }}
                                  name="firebase_content"
                                  placeholder="Enter Firebase Content"
                                  className={`${styles.formControl} form-control`}
                                  maxLength={500}
                                />
                              </Col>
                            </Row>
                          </div>
                          <Row className="mt-5 ">
                            <Col className="my-2" lg="12">
                              <div
                                className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                style={{ borderTop: "1px solid #41a2a84d" }}
                              >
                                <Button
                                  disabled={
                                    createCmsLoading || updateCmsLoading
                                  }
                                  type="submit"
                                  className="d-flex align-items-center justify-content-center commonBtn"
                                >
                                  {createCmsLoading || updateCmsLoading ? (
                                    <LoadingIndicator inline />
                                  ) : (
                                    "Save"
                                  )}
                                </Button>
                                <Button
                                  onClick={() => navigate(MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST)}
                                  type="button"
                                  className="d-flex align-items-center justify-content-center commonBtn"
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </Col>
                </Row>
              </>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddFirebaseNotificationTemplate;
